export default {
  interviews: [],
  interview: undefined,
};
